import React from "react";
import AdminAddMainCharacter from "../../Components/Admin/AdminAddMainCharacter";
import SideBar from "../../Components/Admin/SideBar";

const AdminAddMainCharacterPage = ()=>{
    return (
      <AdminAddMainCharacter />
    )
}

export default AdminAddMainCharacterPage;